import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Link } from 'react-router-dom';

import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

// eslint-disable-next-line react/prefer-stateless-function
class MagazineArchive extends Component {
  render() {
    if (this.props.magazineArchivePage.error) {
      return (
        <section className="wp-page">
          <article className="wp-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.magazineArchivePage.isLoading) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    return (
      <section className="magazine-archive-page">
        <div className="magazine-archive-page__main">
          <h1 className="magazine-archive-page__heading">
            <Link to="/magazine-archives">Magazine Archive</Link>
          </h1>
          {this.props.magazineArchive.map(function mapKeys(yearCollection) {
            return (
              <div
                className="magazine-archive-page__body"
                key={yearCollection.year}
              >
                <h3 className="magazine-archive-page__year-heading">
                  {yearCollection.year}
                </h3>
                {yearCollection.issues.map(issueModel =>
                  <p
                    className="magazine-archive-page__issue"
                    key={issueModel.issue}
                  >
                    <Link to={`/magazine/${issueModel.issue}`}>
                      {get(issueModel, 'text')}
                    </Link>
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    magazineArchivePage: state.magazineArchivePage || { error: true },
    magazineArchive: get(state, 'magazineArchive.data.years') || []
  };
}

MagazineArchive.propTypes = {
  magazineArchivePage: PropTypes.shape({
    error: PropTypes.bool,
    isLoading: PropTypes.bool
  }).isRequired,
  magazineArchive: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default connect(mapStateToProps)(MagazineArchive);



// WEBPACK FOOTER //
// ./src/views/containers/pages/magazine_archive_page/magazine_archive_page.js